module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_7.d69bb316.png";